import { Charts } from './Charts';
import DatabaseChartsDataProvider from './contexts/DatabaseChartsDataContext';

const DatabaseWrapper = () => {
    return (
        <DatabaseChartsDataProvider>
            <Charts />
        </DatabaseChartsDataProvider>
    );
};

export default DatabaseWrapper;
